export default "__VITE_ASSET__CnFu99qM__"